
export {
    search,
}


const search = `/search/`;
